import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { MerChantModel } from '../../../../models/merChantModel';
import { SelectChangeEvent } from '@mui/material';
import { getIdFormSelectBranchData } from '../../../../utils/getIdFormSelectBranchData';
import { ProductMerchantModel } from '../../../../models/productMerchant';
import { handleGetProductByItemCode } from '../../../../utils/getProductByItemCodeFunction';
import moment from 'moment';
import { TagPromotionModel } from '../../../../models/tagPromotion.model';
import { PromotionEnumType } from '../../../../enums/promotionEnum';
import { DiscountTypeEnumPromotion, PromotionTypeEnumPromotion } from '../../../../enums/discountEnum';
import { createPromotionService, updateMultiplePromotionImage } from '../../../../services/promotion';
import { PromotionModel } from '../../../../models/promotion';
import { EN_ACCEPT_LANGUAGE, LA_ACCEPT_LANGUAGE } from '../../../../constants/acceptLanguageApi';
import { useTranslation } from 'react-i18next';
import { IMAGE_PRO_URL } from '../../../../lib/endpoints/promotion';
import { getDateTimeFromRef } from '../../../../utils/dateTimeFormat';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';

interface Props {
  branchData: MerChantModel[];
  tagPromotionData: TagPromotionModel[];
  promotionType: PromotionEnumType;
  onFetchData: Function;
  onClose: VoidFunction;
  selectedData: PromotionModel;
}

const useBuyXGetCBPPromotionController = ({ branchData, tagPromotionData, promotionType, onClose, onFetchData, selectedData }: Props) => {
  const { t, i18n } = useTranslation('global');

  const [getDataProduct, setGetDataProduct] = useState<ProductMerchantModel[]>([]);
  const [getComboProductData, setGetDataComboProductData] = useState<ProductMerchantModel[]>([]);  
  const [openConfirmForm, setOpenConfirmForm] = useState<boolean>(false);
  const [loadingButton, setLoadingButton] = useState<boolean>(false);
  const [selectedProductValue, setSelectedProductValue] = useState<number>(0);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [errorMessageSearchProduct, setErrorMessageSearchProduct] = useState<string>('');

  const [isFlashSale, setIsFlashSale] = useState<boolean>(false);
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [imageToShow, setImageToShow] = useState<string | null>(null);
  const [selectBranchDataValue, setSelectBranchDataValue] = useState<string[]>([]);
  const [selectedTagPromotion, setSelectedTagPromotion] = useState<string>('');
  const [selectedStartDateHour, setSelectedStartDateHour] = useState<string>('');
  const [selectedEndDateHour, setSelectedEndDateHour] = useState<string>('');
  const [selectedFlashSaleStartDateHour, setSelectedFlashSaleStartDateHour] = useState<string>('');
  const [selectedFlashSaleEndDateHour, setSelectedFlashSaleEndDateHour] = useState<string>('');
  const [selectDiscountTypePromotion, setSelectDiscountTypePromotion] = useState<DiscountTypeEnumPromotion>(DiscountTypeEnumPromotion.AMOUNT);
  const [selectedPromotionPerDay, setSelectedPromotionPerDay] = useState<PromotionTypeEnumPromotion>(PromotionTypeEnumPromotion.PROMOTION);

  const itemCodeX = useRef<HTMLInputElement>(null!);
  const promotionName = useRef<HTMLInputElement>(null!);
  const description = useRef<HTMLInputElement>(null!);
  const startDate = useRef<HTMLInputElement>(null!);
  const endDate = useRef<HTMLInputElement>(null!);
  const flashSaleStartDate = useRef<HTMLInputElement>(null!);
  const flashSaleEndDate = useRef<HTMLInputElement>(null!);
  const buyBuyPrice = useRef<HTMLInputElement>(null!);
  const discountPrice = useRef<HTMLInputElement>(null!);
  const limitUse = useRef<HTMLInputElement>(null!);
  const limitUseOfCustomer = useRef<HTMLInputElement>(null!);
  const limitProPerDay = useRef<HTMLInputElement>(null!);

  const getBranchId = getIdFormSelectBranchData(selectBranchDataValue, branchData);
  const roleAdmin = useSelector((state: RootState) => state?.auth?.data?.role?.role_type);

  const handleGetProductX = async (): Promise<void> =>
    handleGetProductByItemCode(
      itemCodeX.current.value,
      setGetDataProduct,
      setErrorMessageSearchProduct
    );

  const handleGetProductBySelect = () => {
    const getProduct = getDataProduct?.find(
      (item: ProductMerchantModel) => item?.price?.quantity === selectedProductValue
    );
    if (getProduct) {
      setGetDataComboProductData((prevDataProductBySelect) => {
        const alreadySelected = prevDataProductBySelect.some(
          (product) => product.id === getProduct.id
        );
        return alreadySelected ? prevDataProductBySelect : [...prevDataProductBySelect, getProduct];
      });
    }
  };

  const handleDeleteProduct = (id: string) => {
    setGetDataComboProductData((prevDataProductBySelect) =>
      prevDataProductBySelect.filter((product: ProductMerchantModel) => product?.id !== id)
    );
  };

  const handleSubmitForm = (): void => {
    if (handleValidate()) {
      setOpenConfirmForm(true);
    }
  };

  const handleValidate = () => {
    if (!selectedTagPromotion) {setErrorMessage(t('validatr_promotion.Please select tag promotion') || '');
      return false;
    }
    if (!promotionName.current.value) {setErrorMessage(t('validatr_promotion.Promotion name is required') || '');
      return false;
    }
    if (!description.current.value) {setErrorMessage(t('validatr_promotion.Description is required') || '');
      return false;
    }
    if (!getComboProductData) {setErrorMessage(t('validatr_promotion.Please select product') || '');
      return false;
    }
    if (!imageFile) {setErrorMessage(t('validatr_promotion.Please Select Image') || '');
      return false;
    }
    if (selectBranchDataValue.length === 0) {setErrorMessage(t('validatr_promotion.Please select Branch') || '');
      return false;
    }

    if (isFlashSale) {
      const flashSaleStart = moment(new Date(flashSaleStartDate.current.value));
      const flashSaleEnd = moment(new Date(flashSaleEndDate.current.value));
      if (!flashSaleStart.isValid()) {setErrorMessage(t('validatr_promotion.Flash sale start date is invalid') || '');
        return false;
      }
      if (!flashSaleEnd.isValid()) {setErrorMessage(t('validatr_promotion.Flash sale end date is invalid') || '');
        return false;
      }
      if (!selectedFlashSaleStartDateHour) {setErrorMessage(t('validatr_promotion.Please select FlashSale start Hour') || '');
        return false;
      }
      if (!selectedFlashSaleEndDateHour) {setErrorMessage(t('validatr_promotion.Please select FlashSale end Hour') || '');
        return false;
      }
      if (flashSaleStart.isAfter(flashSaleEnd)) {
        setErrorMessage(t('validatr_promotion.Flash sale start date must be before flash sale end date') || '');
        return false;
      }
    }

    const start = moment(new Date(startDate.current.value));
    const end = moment(new Date(endDate.current.value));
    if (!start.isValid()) {setErrorMessage(t('validatr_promotion.Start date is invalid') || '');
      return false;
    }
    if (!end.isValid()) {setErrorMessage(t('validatr_promotion.End date is invalid') || '');
      return false;
    }
    if (start.isAfter(end)) {setErrorMessage(t('validatr_promotion.Start date must be before end date') || '');
      return false;
    }
    if (!selectedStartDateHour) {setErrorMessage(t('validatr_promotion.Please select start Hour') || '');
      return false;
    }
    if (!selectedEndDateHour) {setErrorMessage(t('validatr_promotion.Please select end Hour') || '');
      return false;
    }
    if (!validateNumberInput(limitUse.current?.value, t('validatr_promotion.Limit use must be a number'))) 
    {
      return false;
    }
    if (!validateNumberInput(limitUseOfCustomer.current?.value,t('validatr_promotion.Limit use must be a number')))
    {
      return false;
    }
    if (!selectedProductValue) {setErrorMessage(t('validatr_promotion.Please select product') || '');
      return false;
    }
    if (getComboProductData.length === 0) {setErrorMessage(t('validatr_promotion.Please select product') || '')
      return false;
    }

    // Cross-field numeric check
    const limitUseValue = parseInt(limitUse?.current?.value);
    const limitUseOfCustomerValue = parseInt(limitUseOfCustomer?.current?.value);
    const limitProPerDayValue = parseInt(limitProPerDay?.current?.value);
    
    if (limitUseValue < limitUseOfCustomerValue) {
      setErrorMessage(t('validatr_promotion.Limit use of customer must not be exceed limit of promotion') || '')
      return false;
    }

    if (selectedPromotionPerDay === 'per_day') {
      const isValid = validateNumberInput(limitProPerDay.current?.value, t('validatr_promotion.Limit use per day must be a number'));
      if (!isValid) {
        return;
      }
      if (limitUseValue < limitProPerDayValue) {
          setErrorMessage(t('validatr_promotion.Limit use must not be less than limit per day') || '');
          return false; 
      }
      if (limitUseOfCustomerValue < limitProPerDayValue) {
        setErrorMessage(t('validatr_promotion.limit Use Of Customer must not be less than limit per day') || '');
        return false; 
      }
    }

    setErrorMessage('');
    return true;
  };

  const validateNumberInput = (value: string, errorMessage: string): boolean => {
    if (!value) {
      setErrorMessage(t('validatr_promotion.Please enter a number') || '');
      return false;
    }
    if (!/^\d+$/.test(value)) {
      setErrorMessage(errorMessage);
      return false;
    }
    return true;
  };

  const handleSelectedBranch = (event: SelectChangeEvent<any>) => {
    const { target: { value }} = event;
    setSelectBranchDataValue(typeof value === 'string' ? value.split(',') : value);
  };

  const handleSelectPromotionPerDay = (event: ChangeEvent<HTMLInputElement>) => {setSelectedPromotionPerDay(event.target.value as PromotionTypeEnumPromotion)};
  const handleSelectDiscountTypePromotion = (event: ChangeEvent<HTMLInputElement>) => {setSelectDiscountTypePromotion(event.target.value as DiscountTypeEnumPromotion)};
  const handleSelectTagPromotion = (event: SelectChangeEvent<string>) => {setSelectedTagPromotion(event.target.value)};
  const handleCloseConfirmFom = () => {setOpenConfirmForm(false)};

  const handleSelectImage = (file: File) => {
    setImageFile(file);
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2 && reader.result) {
        setImageToShow(reader.result as string);
      }
    };
    reader.readAsDataURL(file);
  };

  const filterTagPromotionType = tagPromotionData?.filter((item: TagPromotionModel) => item?.tagType === promotionType);
 
  const formPromotion = () => ({
    promotionName: promotionName.current.value,
    promotionType: promotionType,
    buyProduct: getComboProductData.map((item) => ({
      uomQuantity: item?.price?.quantity,
      itemcode: item?.price?.itemcode,
    })),
    buyByPrice: parseInt(buyBuyPrice.current.value) || 0,
    discountType: selectDiscountTypePromotion,
    discountPrice: parseInt(discountPrice?.current.value) || 0,
    startDate: getDateTimeFromRef(startDate, selectedStartDateHour),
    endDate: getDateTimeFromRef(endDate, selectedEndDateHour),
    merchantIds: getBranchId,
    tagId: selectedTagPromotion,
    limitUse: parseInt(limitUse.current.value),
    limitUseOfCustomer: parseInt(limitUseOfCustomer.current.value),
    limitUserPerDay: parseInt(limitProPerDay.current.value) || 0,
    flashSale: isFlashSale,
    description: description.current?.value || '',
    ...(isFlashSale && {
      flashSaleStartDate: getDateTimeFromRef(flashSaleStartDate, selectedFlashSaleStartDateHour),
      flashSaleEndDate: getDateTimeFromRef(flashSaleEndDate, selectedFlashSaleEndDateHour),
    }),
  });

  const handleCreatePromotion = async () => {
    try {
      setLoadingButton(true);
      const formData = formPromotion();
      const res: any = await createPromotionService(formData);
      const getPromotionId = res?.promotionId;
      if (imageFile) {
        const uploadImage = await updateMultiplePromotionImage(getPromotionId, imageFile);
        console.log(uploadImage);
      }
      await onFetchData();
      onClose();
    } catch (error: any) {
      if (error.failedItems && error.failedItems.length > 0) {
        // Extract failed merchant messages
        const failedMerchantMessages = error.failedItems
          .map((item: any) => {
            // Find the matching merchant from branchData using the item's merchantId
            const matchingMerchant = branchData?.find((branch) => branch?.id === item.merchantId);
            // Use the merchant ID or a merchant name if available, fallback to item.merchantId if no match
            const merchantIdentifier = i18n.language === LA_ACCEPT_LANGUAGE ? matchingMerchant?.nameLa : matchingMerchant?.nameEn || matchingMerchant?.id || item.merchantId;
            return `${t('validatr_promotion.Sorry, this Item code')} : ${item.itemCode} ${t('validatr_promotion.in Merchant')}: ${merchantIdentifier} ${t('validatr_promotion.has an assigned promotion')}`;
          })
          .join('\n');

        setErrorMessage(failedMerchantMessages);
      } else {
        setErrorMessage(error.message || t('validatr_promotion.Unexpected error occurred.'));
      }

      handleCloseConfirmFom();
    } finally {
      setLoadingButton(false);
    }
  };

  useEffect(() => {
    if (selectedData) {
      promotionName.current.value = selectedData?.promotionName;
      limitProPerDay.current.value = selectedData?.limitUserPerDay?.toString();
      startDate.current.value = moment(selectedData?.startDate, 'MM/DD/YYYY').format('YYYY-MM-DD');
      endDate.current.value = moment(selectedData?.endDate, 'MM/DD/YYYY').format('YYYY-MM-DD');
      flashSaleStartDate.current.value = moment(selectedData?.flashSaleStartDate,'MM/DD/YYYY').format('YYYY-MM-DD');
      flashSaleEndDate.current.value = moment(selectedData?.flashSaleEndDate, 'MM/DD/YYYY').format('YYYY-MM-DD');
      limitUse.current.value = selectedData?.limitUse.toString();
      limitUseOfCustomer.current.value = selectedData?.limitUseOfCustomer.toString();
      description.current.value = selectedData?.description || '';
      buyBuyPrice.current.value = selectedData?.buyByPrice.toString();
      discountPrice.current.value = selectedData?.discountPrice.toString();
      setImageToShow(IMAGE_PRO_URL + selectedData?.image?.url);
      setSelectDiscountTypePromotion(selectedData?.discountType as DiscountTypeEnumPromotion);
      setSelectedProductValue(selectedData?.buyProduct[0]?.quantity);
      setSelectedStartDateHour(moment(selectedData?.startDate, 'MM/DD/YYYY,HH:mm:ss').format('HH'));
      setSelectedEndDateHour(moment(selectedData?.endDate, 'MM/DD/YYYY,HH:mm:ss').format('HH'));
      setSelectedFlashSaleStartDateHour(moment(selectedData?.flashSaleStartDate, 'MM/DD/YYYY,HH:mm:ss').format('HH'));
      setSelectedFlashSaleEndDateHour(moment(selectedData?.flashSaleEndDate, 'MM/DD/YYYY,HH:mm:ss').format('HH'));
      setSelectedTagPromotion(selectedData?.tagId);
      setIsFlashSale(selectedData?.flashSale);
      setSelectBranchDataValue([
        i18n.language === LA_ACCEPT_LANGUAGE
          ? selectedData?.branch?.nameLa
          : i18n.language === EN_ACCEPT_LANGUAGE
          ? selectedData?.branch?.nameEn
          : selectedData?.branch?.nameLa,
      ]);
      if (selectedData?.limitUserPerDay && selectedData?.limitUserPerDay >= 1) {
        setSelectedPromotionPerDay(PromotionTypeEnumPromotion.PER_DAY);
      } else {
        setSelectedPromotionPerDay(PromotionTypeEnumPromotion.PROMOTION);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedData]);

  return {
    roleAdmin,
    isFlashSale,
    imageToShow,
    promotionName,
    description,
    branchData,
    itemCodeX,
    filterTagPromotionType,
    flashSaleEndDate,
    flashSaleStartDate,
    startDate,
    endDate,
    limitUse,
    limitProPerDay,
    limitUseOfCustomer,
    buyBuyPrice,
    discountPrice,
    getDataProduct,
    getComboProductData,
    loadingButton,
    errorMessage,
    openConfirmForm,
    errorMessageSearchProduct,
    selectedTagPromotion,
    selectBranchDataValue,
    selectedPromotionPerDay,
    selectDiscountTypePromotion,
    selectedProductValue,
    selectedStartDateHour,
    selectedEndDateHour,
    selectedFlashSaleStartDateHour,
    selectedFlashSaleEndDateHour,
    handleGetProductX,
    handleSelectedBranch,
    handleSelectPromotionPerDay,
    handleSelectImage,
    handleSelectTagPromotion,
    handleGetProductBySelect,
    handleSubmitForm,
    handleDeleteProduct,
    handleCloseConfirmFom,
    handleSelectDiscountTypePromotion,
    handleCreatePromotion,
    handleSelectFlashSale: (newValue: boolean) => setIsFlashSale(newValue),
    handleSelectedProduct: (event: SelectChangeEvent<any>) => setSelectedProductValue(event.target.value),
    handleSelectedStartDateHour: (event: React.ChangeEvent<HTMLInputElement>) => setSelectedStartDateHour(event.target.value),
    handleSelectedEndDateHour: (event: React.ChangeEvent<HTMLInputElement>) => setSelectedEndDateHour(event.target.value),
    handleSelectedFlashSaleStartDateHour: (event: React.ChangeEvent<HTMLInputElement>) => setSelectedFlashSaleStartDateHour(event.target.value),
    handleSelectedFlashSaleEndDateHour: (event: React.ChangeEvent<HTMLInputElement>) => setSelectedFlashSaleEndDateHour(event.target.value),
  };
};
export default useBuyXGetCBPPromotionController;
